var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDioxin06(_ref, svgRef) {
  var {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 739.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.31,
    y: 7.03,
    width: 19.35,
    height: 583.79,
    transform: "translate(163.96 597.84) rotate(180)",
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.66 590.81 72.31 610.16 72.31 590.81 91.66 590.81",
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.95,
    y: 7.03,
    width: 19.35,
    height: 583.79,
    style: {
      fill: "#eee7da"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400 420 0 264.07 0 0 400 0 400 420",
    style: {
      fill: "#9bc6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.15 665.41 0.81 264.07 233.42 31.46 585.49 383.53 651.23 416.33 402.15 665.41",
    style: {
      fill: "#9bc6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.08,446.49l13.68-13.69L233.34,31.38,219.66,45.07Zm-27.37,27.36,13.68-13.68L206,58.75,192.29,72.43Zm-27.36,27.37L580,487.53,178.61,86.11,164.93,99.8ZM539,528.58l13.68-13.68L151.24,113.48l-13.68,13.68ZM511.62,556l13.68-13.68L123.88,140.85,110.2,154.53Zm-27.37,27.36,13.68-13.68L96.51,168.21,82.83,181.89Zm-27.37,27.37L470.57,597,69.15,195.58,55.47,209.26ZM429.52,638l13.68-13.68L41.78,222.94,28.1,236.63Zm0,0,13.68-13.68L41.78,222.94,28.1,236.63Zm-27.37,27.37,13.69-13.68L14.42,250.31.73,264Z",
    style: {
      fill: "#cde2ee"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.95 590.81 72.31 610.16 72.31 590.81 52.95 590.81",
    style: {
      fill: "#eee7da"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_42",
    "data-name": "Ebene 42"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "400 690.62 402.15 665.41 -10.65 252.61 -24.33 266.29 400 690.62",
    style: {
      fill: "#eee7da"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dioxine_OK",
    "data-name": "Dioxine OK"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.14,
    y: 97.45,
    width: 51.19,
    height: 50.36,
    style: {
      fill: "#296a8d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.61,
    y: 33.79,
    width: 2.26,
    height: 12.78,
    style: {
      fill: "#f6f3f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.74 42.55 166.14 70.64 217.33 70.64 191.74 42.55",
    style: {
      fill: "#f6f3f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.14,
    y: 151.83,
    width: 51.19,
    height: 4.01,
    style: {
      fill: "#296a8d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.14,
    y: 155.84,
    width: 51.19,
    height: 21.7,
    style: {
      fill: "#f0f5f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.14,
    y: 147.81,
    width: 51.19,
    height: 4.01,
    style: {
      fill: "#f0f5f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.14,
    y: 70.64,
    width: 51.19,
    height: 26.81,
    style: {
      fill: "#f0f5f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.28,97.45c-2.87,0-8.59,3.31-8.88,7.11a26.87,26.87,0,0,0,1.68,11.21c1.78,5.23,6.41,16.81-2.47,16.81s-4.25-11.58-2.48-16.81a27.1,27.1,0,0,0,1.69-11.21c-.3-3.8-6-7.11-8.88-7.11",
    style: {
      fill: "#f0f5f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.28,97.45c-2.87,0-8.59,3.31-8.88,7.11a26.87,26.87,0,0,0,1.68,11.21c1.78,5.23,6.41,16.81-2.47,16.81s-4.25-11.58-2.48-16.81a27.1,27.1,0,0,0,1.69-11.21c-.3-3.8-6-7.11-8.88-7.11",
    style: {
      fill: "#f0f5f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.61,130.76h.08c6.05,0,3.32-7.52,1.95-11.45C193.8,124.08,194.05,128.91,190.61,130.76Z",
    style: {
      fill: "#296a8d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.78,
    y: 51.93,
    width: 14.23,
    height: 5.56,
    rx: 1.47,
    transform: "translate(17.23 148.48) rotate(-47.61)",
    style: {
      fill: "#296a8d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.35,
    y: 55.3,
    width: 18.06,
    height: 1.54,
    rx: 0.36,
    transform: "translate(16.71 150.02) rotate(-47.61)",
    style: {
      fill: "#296a8d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.7,
    cy: 89.37,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 147.75,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.34,
    cy: 164.83,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.67,402.9a5,5,0,0,1-5.06,5.64H227.34a4.62,4.62,0,0,1-4.7-5.59l8.62-49.82a7,7,0,0,1,6.64-5.59H324a6.48,6.48,0,0,1,6.28,5.64Z",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.67,400.52a5,5,0,0,1-5.11,5.65h-95a4.68,4.68,0,0,1-4.75-5.6l7.48-45.7a6.91,6.91,0,0,1,6.59-5.59h80.06a6.4,6.4,0,0,1,6.23,5.64Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.57,400.58c-.54-8-5-19.51-12.06-23.8,4.32,5.12,7,13.06,7.39,18.93.83,12.21-7.06,20.85-16.76,20.85a16,16,0,0,1-13-6.8c2.53,7.88,9.09,12.92,16.71,12.92C270.09,422.68,278.45,413.52,277.57,400.58Z",
    style: {
      fill: "#e7e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.14,416.56c9.7,0,17.59-8.64,16.76-20.85-.4-5.87-3.07-13.81-7.39-18.93a10.86,10.86,0,0,0-5.71-1.7c-10.28,0-17.09,15.55-17.77,25.5a24.71,24.71,0,0,0,1.06,9.18A16,16,0,0,0,256.14,416.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.33,400.58c-.54-8-5-19.51-12.06-23.8,4.32,5.12,7,13.06,7.39,18.93.83,12.21-7.06,20.85-16.76,20.85a16,16,0,0,1-13-6.8c2.53,7.88,9.09,12.92,16.72,12.92C308.85,422.68,317.21,413.52,316.33,400.58Z",
    style: {
      fill: "#e7e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.9,416.56c9.7,0,17.59-8.64,16.76-20.85-.4-5.87-3.07-13.81-7.39-18.93a10.85,10.85,0,0,0-5.7-1.7c-10.29,0-17.1,15.55-17.77,25.5a24.51,24.51,0,0,0,1.05,9.18A16,16,0,0,0,294.9,416.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.58,
    cy: 390.17,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.21,407.49c-.54-8-5-19.51-12.06-23.8,4.32,5.12,7,13.06,7.39,18.93.83,12.22-7.06,20.85-16.76,20.85a16,16,0,0,1-13-6.8c2.53,7.88,9.09,12.92,16.71,12.92C328.73,429.59,337.09,420.43,336.21,407.49Z",
    style: {
      fill: "#e7e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.78,423.47c9.7,0,17.59-8.63,16.76-20.85-.4-5.87-3.07-13.81-7.39-18.93a10.86,10.86,0,0,0-5.71-1.7c-10.28,0-17.09,15.56-17.77,25.5a24.71,24.71,0,0,0,1.06,9.18A16,16,0,0,0,314.78,423.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.69,407.49c-.54-8-5-19.51-12.06-23.8,4.32,5.12,7,13.06,7.39,18.93.83,12.22-7.06,20.85-16.76,20.85a16,16,0,0,1-13-6.8c2.52,7.88,9.09,12.92,16.71,12.92C251.21,429.59,259.57,420.43,258.69,407.49Z",
    style: {
      fill: "#e7e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.26,423.47c9.7,0,17.59-8.63,16.76-20.85-.4-5.87-3.07-13.81-7.39-18.93a10.86,10.86,0,0,0-5.71-1.7c-10.28,0-17.09,15.56-17.77,25.5a24.31,24.31,0,0,0,1.06,9.18A16,16,0,0,0,237.26,423.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.45,407.49c-.54-8-5-19.51-12.06-23.8,4.32,5.12,7,13.06,7.39,18.93.83,12.22-7.06,20.85-16.76,20.85a16,16,0,0,1-13-6.8c2.53,7.88,9.09,12.92,16.71,12.92C290,429.59,298.33,420.43,297.45,407.49Z",
    style: {
      fill: "#e7e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,423.47c9.7,0,17.59-8.63,16.76-20.85-.4-5.87-3.07-13.81-7.39-18.93a10.86,10.86,0,0,0-5.71-1.7c-10.28,0-17.09,15.56-17.77,25.5a24.71,24.71,0,0,0,1.06,9.18A16,16,0,0,0,276,423.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.23,
    cy: 406.64,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.68,413.88,223,443.22a4.76,4.76,0,0,0,4.69,4.45h25.34a4.73,4.73,0,0,0,4.67-4.45l.76-16.36a28,28,0,0,1,.61-5.35h1a28.81,28.81,0,0,1,.64,5.35l.92,16.36a4.79,4.79,0,0,0,4.71,4.45h25.35a4.75,4.75,0,0,0,4.68-4.45l.83-16.35a27.66,27.66,0,0,1,.62-5.35h1a27.4,27.4,0,0,1,.6,5.35l.77,16.36a4.73,4.73,0,0,0,4.66,4.45h25.35a4.77,4.77,0,0,0,4.69-4.45l1.36-29.34a4.66,4.66,0,0,0,0-.65H221.7A3.51,3.51,0,0,0,221.68,413.88Z",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.32 408.54 220.32 413.23 221.7 413.23 336.25 413.23 337.01 413.23 337.01 408.54 220.32 408.54",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.63,
    cy: 233.79,
    r: 65.69,
    style: {
      fill: "#fff",
      stroke: "#cce1e2",
      strokeMiterlimit: 10,
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.63,
    cy: 233.79,
    r: 41.31,
    style: {
      fill: "#fff",
      stroke: "#cce1e2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.77,225.7h0c-.27-.88-.5-1.64-.7-2.16-.87-2.36-3.66-3.38-5.21-2.47-.46.27-1,.63-1.5,1h0c-1.27.82-2.68,1.52-4,.58-1.85-1.34-9.19-8-14.84-7.64-1.65.11-3.62.19-5.64.25.15.15.3.28.44.4s.28.22.4.31a19.34,19.34,0,0,0,3,1.61,19.34,19.34,0,0,1-3-1.61c-.12-.09-.26-.19-.4-.31s-.29-.25-.44-.4c-2.92.1-5.92.17-8.17.26h0c-1.46.06-2.61.13-3.22.22a31.45,31.45,0,0,1-6.29-.19c-1.11-.12-2.11-.27-2.73-.4-2.24-.47-6.32-2.88-8.8-4.66h0a15.07,15.07,0,0,1-1.85-1.5,27,27,0,0,0-5.07-4,7.92,7.92,0,0,0-2-.9c-2.14-.53-7.56-1.58-8.18.87s-1,5.92-3.94,9.7-5.89,7.95-6.26,12.82-.4,7.05-1.24,8.71-1.91,1.86-.66,5c.56,1.4,1,2.64,1.54,4.07h0l.45,1.44c.76,2.6,1.88,7.07,2.46,8.78a66.4,66.4,0,0,1,4.42,5.26c1.13,1.11,6.56,4.67,8.35,5,1.23.2,3.22,1.31,5.49,2.2l.74.28c.75.22,2.15.62,2.74.73l1.14.2h0l2.26.37h0c5.65.9,14.79,2.2,16,2.14,1.58-.08,11.57-1.18,13.15-1,1,.12,4.63-1.66,8.21-4.14.65-.45,1.5-1.15,1.92-1.42a31.66,31.66,0,0,0,4-3.77c3.89-4.7,12.45-12.6,13.17-14.88a11.23,11.23,0,0,1,1.32-2.53c.4-.61.84-1.23,1.29-1.85l1-1.26a20.54,20.54,0,0,0,1.25-2.05c.49-.86,1.25-2.5,2-4.28C362.55,232,361.54,228.29,360.77,225.7Z",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,219.32c-1.27.81-2.69,1.52-4,.57-1.85-1.33-9.19-8-14.84-7.63-1.65.1-3.63.18-5.65.25a8.6,8.6,0,0,0,.85.7c2.76,1.9,6.3,2.66,8.66,4.51s4.71,2.53,6.74,7.11,1.09,4.07,4.12,5c1.32.39,3.3.16,5.18.8a26.74,26.74,0,0,0,1.58-6.07C352.87,222.48,351.87,220.85,350,219.32Z",
    style: {
      fill: "#de666f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.72,215.25a26.82,26.82,0,0,0,8.11-2.46c-1.12-.12-2.11-.26-2.73-.39-2.24-.48-6.32-2.89-8.8-4.67a3.36,3.36,0,0,1-2.64,1.65c-2.56.15-4.79-2.68-6.72-.63s-6.31,3.57-7.05,9.88c-.43,3.67-.91,6.17-1.22,8.07C285.26,218.49,296.71,215.52,299.72,215.25Z",
    style: {
      fill: "#de666f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,224c-2.2-3.14-4.61-5.73-9.24-6.39a24.39,24.39,0,0,1-11.16-4.87c-1.46,0-2.61.12-3.22.21a31.45,31.45,0,0,1-6.29-.19,26.82,26.82,0,0,1-8.11,2.46c-3,.27-14.46,3.24-21.05,11.45a18.25,18.25,0,0,0-.34,3.43c.09,2.27-.65,3.39,1,3.7a6,6,0,0,1,4.63,4.24c.51,2.41-.51,3.89,1.06,4.31s9.07,2.89,9.56,3,.37-.75-1.41-2.5-4.91-4-2.16-3.57,6.47,4.69,4.37.49-2-6.23-.92-4.65,2.59,3.13,2.67,2-1.5-2.92.61-5.59,7.49-4.39,4.75-2.89a6.57,6.57,0,0,0-3.7,6.25c.13,2.37,1.74,5.11,3.82,6s3.47,3.13,5.95,3.47a73.9,73.9,0,0,0,8.84.12c1.94,0,2.35-.25,5.07-2s8-6,5.33-3.1-7.58,12.8-5.12,12.52,4.85-2.39,4.24,1.19.29,3.66.83,3.93.13,1.46,3,.45,6.74-5.15,7-5.71,1.06-2.93-2.36-3.88-4.17-1.82-1-5,5.86-8.13,5.37-11.26S340,227.2,337.74,224Z",
    style: {
      fill: "#e9999f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.39,223h0c-.26-.89-.5-1.65-.69-2.17-.87-2.36-3.67-3.38-5.22-2.47-.45.27-1,.63-1.49,1,1.88,1.53,2.88,3.16,2.64,5.21a26.74,26.74,0,0,1-1.58,6.07s3.07,1.24,3.77,3.65a19.67,19.67,0,0,1,.95,5.09l1-1.27a20.54,20.54,0,0,0,1.25-2c.49-.85,1.25-2.5,2-4.28C359.17,229.28,358.16,225.56,357.39,223Z",
    style: {
      fill: "#e9999f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.5,265.47c.76.23,2.16.63,2.75.74l3.44.57a7,7,0,0,1,.34-2.59,6.68,6.68,0,0,1-1.54-.28c-.46-.2-2-.65-2.48-.76s-6.72-2.32-6.92-2.35a39.42,39.42,0,0,1-4.55-2.95c-1.07-.86-4.45-4.2-4.81-4.65s-1.82-6.47-2.24-6.79c-.39-1.63-.68-2.92-.71-3a24.33,24.33,0,0,1,1.83-11.64h-.07c-1.41-.28-1.21-.57-.93-1.73s2.09-2.13,1.62-5.11-1.55-2.93-1-5.53,2-1.09,2.41-1.54a22.44,22.44,0,0,0,3.68-6.56c.68-2.53,1.72-2.55,3.52-3.39s2.09-3.45,2.24-4.51c.05-.39,1-.75,2.31-1.06a8.45,8.45,0,0,0-2-.9c-2.14-.53-7.56-1.58-8.18.88s-1.05,5.92-3.94,9.7-5.89,7.94-6.26,12.82-.41,7-1.24,8.71-1.92,1.85-.66,5c.56,1.4,1,2.64,1.54,4.08h0l.45,1.43c.75,2.6,1.88,7.07,2.45,8.78a64.6,64.6,0,0,1,4.43,5.27c1.13,1.1,6.56,4.66,8.35,4.95,1.23.21,3.21,1.32,5.48,2.2Z",
    style: {
      fill: "#de666f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.67,252.61c-1.35.6-5.12.39-7.25-.56s-4.24-2.22-5.77-2.75-10.17-4.35-14.16-5.57-2.25-2.23-1.69-3.94-2-1.17-4.19-1.15-3.14-2.41-2.46-4.17.79-2.46-.54-2.75c-.16.37-.31.75-.46,1.14l-.12.34c-.1.29-.19.57-.28.87l-.12.39c-.09.3-.17.61-.24.92l-.09.34a25.86,25.86,0,0,0-.45,2.75.86.86,0,0,0,0,.16c0,.42-.08.86-.1,1.3,0,.1,0,.2,0,.3,0,.42,0,.84,0,1.27v.28c0,.52,0,1,.07,1.57h0c0,.13.32,1.42.71,3,.42.32,1.89,6.33,2.24,6.79s3.74,3.79,4.81,4.65a39.42,39.42,0,0,0,4.55,2.95c.2,0,6.47,2.25,6.92,2.35s2,.56,2.48.76a6.68,6.68,0,0,0,1.54.28c1.51-4.81,5.21-2.22,7.22-2.33a47.81,47.81,0,0,0,5-.24c2.53-.32,4.85-4.26,5.41-5.89S313,252,311.67,252.61Z",
    style: {
      fill: "#e9999f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.39,266.4h0l2.3.38Z",
    style: {
      fill: "#fcf7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.77,239.34a19.67,19.67,0,0,0-.95-5.09,4.29,4.29,0,0,0-.19-.5l-.07-.15-.18-.32-.1-.15a3.46,3.46,0,0,0-.22-.31l-.09-.11-.34-.39a9,9,0,0,0-2.56-1.72c-1.89-.65-3.88-.41-5.2-.8-3-.9-2.06-.33-4.12-5s-4.36-5.23-6.74-7.11-5.9-2.61-8.66-4.51a8.6,8.6,0,0,1-.85-.7c-2.91.09-5.91.16-8.16.26a24.39,24.39,0,0,0,11.16,4.87c4.64.66,7,3.25,9.24,6.39s1.53,4.51,2,7.61-2.21,8.11-5.37,11.26-2.36,4,1,5,2.67,3.32,2.36,3.88-4.19,4.68-7,5.71-2.43-.18-3-.45-1.44-.34-.83-3.93-1.77-1.46-4.24-1.19,2.45-9.66,5.12-12.52-2.59,1.32-5.33,3.1-3.13,2-5.07,2a73.9,73.9,0,0,1-8.84-.12c-2.48-.34-3.86-2.57-5.95-3.47s-3.69-3.62-3.82-6a6.59,6.59,0,0,1,3.7-6.25c2.74-1.5-2.63.21-4.75,2.89s-.53,4.49-.61,5.59-1.57-.45-2.67-2-1.15.52.92,4.65-1.59-.08-4.37-.49.4,1.84,2.16,3.57,1.9,2.56,1.41,2.5-8-2.54-9.56-3-.55-1.9-1.06-4.31a6,6,0,0,0-4.63-4.24c-1.65-.31-.91-1.43-1-3.7a18.25,18.25,0,0,1,.34-3.43h0c.31-1.9.79-4.4,1.22-8.07.74-6.31,5.13-7.83,7.05-9.88s4.16.78,6.72.63a3.36,3.36,0,0,0,2.64-1.65,14.18,14.18,0,0,1-1.85-1.5,27.14,27.14,0,0,0-5.08-3.95c-1.32.31-2.26.67-2.31,1.06-.15,1.06-.43,3.67-2.24,4.51s-2.84.86-3.52,3.39a22.44,22.44,0,0,1-3.68,6.56c-.44.45-1.89-1.05-2.41,1.54s.55,2.56,1,5.53-1.34,3.95-1.62,5.11-.48,1.45.93,1.73h.07c1.33.29,1.2,1,.54,2.75s.25,4.18,2.46,4.17,4.75-.55,4.19,1.15-2.25,2.74,1.69,3.94,12.63,5.05,14.16,5.57,3.67,1.81,5.77,2.75,5.9,1.16,7.25.56,3.54,1.49,3,3.12-2.88,5.57-5.41,5.89a47.81,47.81,0,0,1-5,.24c-2,.11-5.71-2.48-7.22,2.33a7,7,0,0,0-.34,2.59c5.65.89,14.78,2.2,16,2.13,1.58-.08,11.57-1.18,13.15-1,1,.12,4.63-1.66,8.21-4.14.65-.45,1.5-1.15,1.92-1.42a32.18,32.18,0,0,0,4-3.76c3.88-4.71,12.45-12.61,13.17-14.89a11.44,11.44,0,0,1,1.32-2.53c.4-.6.84-1.22,1.28-1.84Z",
    style: {
      fill: "#f5f3ef"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.65,
    cy: 259,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.51,
    cy: 237.53,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.38,
    cy: 218.01,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.53,
    cy: 284.35,
    r: 65.69,
    style: {
      fill: "#fff",
      stroke: "#cce1e2",
      strokeMiterlimit: 10,
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.53,
    cy: 284.35,
    r: 41.31,
    style: {
      fill: "#fff",
      stroke: "#cce1e2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.33,301.08c-.42-3.88-6.4-11.24-9.6-13.3h0c3-1.77,8.47-7.87,9.83-11.85l.29,0-.27-.09a5.46,5.46,0,0,0,.26-1c-3.22-1.19-19.37-5.5-27.58,5.46-17.49-12.34-29.7-20.69-49.8-21.08a46.77,46.77,0,0,0-12.83,1.43l-.17,0,.39.21-.39-.21c-11.3,3-17.09,9.76-19.12,12.64-2.24,3.17-5.28,8.55-6.2,11.79h0a6.14,6.14,0,0,0-.29,1.69,2.88,2.88,0,0,0,.54,1.34c1.25-.28,1.26-.28,0,0,2,3.22,9.33,8.93,11.47,10.26,2.46,1.55,12.82,5.71,24.23,6.93,14.42,1.55,27.2-2.15,39.36-6.38,0,.14,0,.27,0,.42A11.92,11.92,0,0,0,178,301.81,33.94,33.94,0,0,0,194.33,301.08Z",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,277.76c-17.49-12.33-29.69-20.69-49.79-21.08a46.36,46.36,0,0,0-12.83,1.44c.61.26,1.19.52,1.7.78,4.61,2.33,18,13.93,4.22,27.67l-.08.09c-.42.41-.87.83-1.34,1.24l-.21.2c-.54.46-1.1.93-1.7,1.4l0,0c5.08-1.62,7.07-2.72,8.46-3.67.48-.33,1.47-1.05,2.77-1.94,3.48-2.41,9.24-6.18,13.9-7.73,6.42-2.12,10.75-.41,9.09,8.17l43.32.85c3.28-1.94,9.54-9.06,10.12-12.92C189.4,271.11,173.25,266.8,165,277.76Z",
    style: {
      fill: "#35586d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.1,276.2c-4.66,1.55-10.42,5.32-13.9,7.73l23,.44C140.85,275.79,136.52,274.08,130.1,276.2Z",
    style: {
      fill: "#79adc8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.17,278.57c-1.62-1.84-6.53-.6-8.12,0a73.45,73.45,0,0,0-12.85,5.36l23,.44A7.19,7.19,0,0,0,137.17,278.57Z",
    style: {
      fill: "#5399be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.28,289c-2.75-3.79-8.16-6.43-14.43-6.56a22.08,22.08,0,0,0-2.95.15,5.63,5.63,0,0,0-.28,1.69,2.93,2.93,0,0,0,.53,1.33,22.69,22.69,0,0,1,5.28-.53A20,20,0,0,1,94.28,289Z",
    style: {
      fill: "#35586d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.42,280A57,57,0,0,1,86,269.92a30.61,30.61,0,0,1,5.8-6A31.62,31.62,0,0,0,83.1,272a61.33,61.33,0,0,0-4.62,7.86c-.46.95-.87,1.86-1.18,2.69a22.65,22.65,0,0,1,2.34-.1h.21c5.6.11,10.5,2.24,13.44,5.39C91.24,283.82,86.37,280.77,80.42,280Z",
    style: {
      fill: "#5399be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.63,273.41c-4-1.33-18.7-4.74-26.67,5.09C174.29,272.12,185.57,272.34,192.63,273.41Z",
    style: {
      fill: "#79adc8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.65,259.14c17.15.45,29.88,5.33,43,13.19-12.55-8.31-23.51-13.61-39.42-13.92a48.31,48.31,0,0,0-10.48.89A67.82,67.82,0,0,1,111.65,259.14Z",
    style: {
      fill: "#79adc8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.12,258.9c-.51-.26-1.09-.52-1.7-.78l-.17,0c5.18,2.63,21.5,16.93-2.16,32.83,1.9-.53,3.49-1,4.88-1.44C124.12,274.53,109.06,261.4,104.12,258.9Z",
    style: {
      fill: "#79adc8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.25,258.15c-11.31,3-17.1,9.77-19.13,12.64-2.24,3.18-5.28,8.56-6.2,11.8l.4,0h0c.31-.83.72-1.74,1.18-2.69A61.33,61.33,0,0,1,83.1,272a31.62,31.62,0,0,1,8.74-8.12,30.61,30.61,0,0,0-5.8,6A57,57,0,0,0,80.42,280a19.47,19.47,0,0,1,8.9,3.38l19.05.37C119,271,106.63,260.38,102.25,258.15Z",
    style: {
      fill: "#79adc8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51,285.22l-43.32-.85-23-.44c-1.3.89-2.29,1.61-2.77,1.94-1.39.95-3.38,2.05-8.46,3.67l0,0s0,0,0,0c-1.39.44-3,.91-4.88,1.44a38.26,38.26,0,0,0,8.28-7.21l-19.05-.37a12.89,12.89,0,0,1,4,4.43,12.25,12.25,0,0,1,1,1.17,20,20,0,0,0-11.85-3.92,22.55,22.55,0,0,0-5.27.53c2,3.23,9.34,8.93,11.47,10.27,2.47,1.54,12.82,5.7,24.23,6.93,19.46,2.09,35.94-5.38,51.91-10.82,7.77,11.27,24.08,7.59,27.35,6.53C191.69,294.64,185.72,287.28,182.51,285.22Z",
    style: {
      fill: "#5399be"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.65,
    cy: 270.87,
    r: 4.51,
    style: {
      fill: "#35586d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.19,284.37l-23-.44s16,6.86,17.82,7.38C137.53,292.3,138.86,286.18,139.19,284.37Z",
    style: {
      fill: "#35586d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.65,
    cy: 270.87,
    r: 2.62,
    style: {
      fill: "#5399be"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.87,
    cy: 271.2,
    rx: 0.74,
    ry: 0.85,
    transform: "translate(-171.27 367.76) rotate(-88.88)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.35,
    cy: 268.89,
    rx: 1.16,
    ry: 1.56,
    transform: "translate(-170.45 363.98) rotate(-88.88)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.11,
    cy: 297.07,
    r: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.11,296.88a10,10,0,1,1,9.81,10.2A10,10,0,0,1,154.11,296.88ZM163.88,309a11.92,11.92,0,1,0-11.69-12.15A11.91,11.91,0,0,0,163.88,309Z",
    style: {
      fill: "#fae66b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.72,290.46a9.31,9.31,0,0,0-6.42-2.74c-.18,0-.36,0-.54,0l1.22,6.8Z",
    style: {
      fill: "#fae66b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39,288.12a9.39,9.39,0,0,0-6.28,6.42l9.33.85Z",
    style: {
      fill: "#fae66b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,300.1a9.57,9.57,0,0,0,.5-2.84,9.36,9.36,0,0,0-1.38-5.06l-6,4.41S169.55,298.35,173,300.1Z",
    style: {
      fill: "#fae66b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.07,296.61l6-4.41a9.22,9.22,0,0,0-1.37-1.74L165,294.53l-1.22-6.8a9.32,9.32,0,0,0-2.37.39l3.05,7.27-9.33-.85a10.49,10.49,0,0,0-.31,1.69l9.33-.05-5.45,8.51a9.35,9.35,0,0,0,2.17,1.14l4-8.74,6.64,5.79A9.54,9.54,0,0,0,173,300.1C169.55,298.35,166.07,296.61,166.07,296.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8,296.23c0,.22,0,.44,0,.66a9.36,9.36,0,0,0,3.92,7.8l5.45-8.51Z",
    style: {
      fill: "#fae66b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.85,305.83a9.22,9.22,0,0,0,3.08.6,9.32,9.32,0,0,0,7.51-3.55l-6.64-5.79Z",
    style: {
      fill: "#fae66b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.55,
    cy: 273.94,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.26,
    cy: 289.03,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.64,
    cy: 438.03,
    r: 4.78,
    style: {
      fill: "#e78d38"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDioxin06);
export default __webpack_public_path__ + "static/media/dioxin_06.e8457c10289f37bdff878d96fc394d1d.svg";
export { ForwardRef as ReactComponent };